import thirdPartyLeakageS1 from "@/assets/png/ThirdPartyLeakage/thirdPartyLeakageS1.png";
import thirdPartyLeakageS2 from "@/assets/png/ThirdPartyLeakage/thirdPartyLeakageS2.png";
import thirdPartyLeakageS3 from "@/assets/png/ThirdPartyLeakage/thirdPartyLeakageS3.png";
import thirdPartyLeakageS4 from "@/assets/png/ThirdPartyLeakage/thirdPartyLeakageS4.png";
import thirdPartyLeakageS5 from "@/assets/png/ThirdPartyLeakage/thirdPartyLeakageS5.png";
import thirdPartyLeakageS6 from "@/assets/png/ThirdPartyLeakage/thirdPartyLeakageS6.png";

import { Answer, IQuizList, ISlides } from "@/pages/SecurityAwareness/types";

export const thirdPartyLeakage: Array<IQuizList> = [
  {
    name: "step1",
    question: "1. What is data leakage via third-party services?",
    options: [
      { value: "1", label: "Slowing down system performance" },
      {
        value: Answer.Correct,
        label:
          "Unintended exposure of sensitive data through external apps or vendors",
      },
      { value: "3", label: "Using outdated company software" },
      { value: "4", label: "Excessive use of company internet" },
    ],
  },
  {
    name: "step2",
    question:
      "2. Which of the following most commonly leads to third-party data leakage?",
    options: [
      { value: "1", label: "Using strong passwords" },
      {
        value: Answer.Correct,
        label: "Unapproved use of cloud storage or collaboration tools",
      },
      { value: "3", label: "Installing software updates" },
      { value: "4", label: "Restricting app permissions" },
    ],
  },
  {
    name: "step3",
    question:
      "3. What is the best way to minimize risks when using third-party services?",
    options: [
      { value: "1", label: "Allow vendors full unrestricted access" },
      { value: "2", label: "Share sensitive data over personal email" },
      {
        value: Answer.Correct,
        label: "Audit vendor security and apply least privilege access",
      },
      { value: "4", label: "Ignore vendor compliance requirements" },
    ],
  },
  {
    name: "step4",
    question: "4. What was the lesson from the Twitter vendor breach in 2020?",
    options: [
      { value: "1", label: "Vendors never cause issues" },
      {
        value: Answer.Correct,
        label: "Even trusted vendors can be a weak security link",
      },
      { value: "3", label: "Passwords are more important than vendor checks" },
      { value: "4", label: "Cloud services are always safe by default" },
    ],
  },
  {
    name: "step5",
    question: "5. What should employees do to prevent data leakage?",
    options: [
      { value: "1", label: "Use any tool they like for convenience" },
      { value: "2", label: "Share sensitive files over personal messengers" },
      {
        value: Answer.Correct,
        label:
          "Use only company-approved services and follow security training",
      },
      { value: "4", label: "Disable all encryption to simplify access" },
    ],
  },
];

export const thirdPartyLeakageSlides: Array<ISlides> = [
  { id: 1, content: <img src={thirdPartyLeakageS1} alt="slide1" /> },
  { id: 2, content: <img src={thirdPartyLeakageS2} alt="slide2" /> },
  { id: 3, content: <img src={thirdPartyLeakageS3} alt="slide3" /> },
  { id: 4, content: <img src={thirdPartyLeakageS4} alt="slide4" /> },
  { id: 5, content: <img src={thirdPartyLeakageS5} alt="slide5" /> },
  { id: 6, content: <img src={thirdPartyLeakageS6} alt="slide6" /> },
];
